import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Runtime, account, analytics } from "@silvertours/front-entities";
import { http } from "@silvertours/front-shared";
import { useCallback, useEffect, useMemo, useState } from "react";
import { LoginContext } from "./LoginState";
var LoginProvider = function(param) {
    var children = param.children;
    var ref = useState(false), isLoggedIn = ref[0], setLoggedIn = ref[1];
    var ref1 = useState(false), showLogin = ref1[0], setShowLogin = ref1[1];
    var ref2 = useState(false), showMobileLogin = ref2[0], setShowMobileLogin = ref2[1];
    var ref3 = useState(""), username = ref3[0], setUsername = ref3[1];
    var ref4 = useState(null), error = ref4[0], setError = ref4[1];
    var sessionData = account.useSessionData();
    var formatSessionUrl = Runtime.useAccountConfig().formatSessionUrl;
    var url = formatSessionUrl(http.API.accountSession);
    var getAccountSession = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var res, e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        account.getAccountSession(url)
                    ];
                case 1:
                    res = _state.sent();
                    setLoggedIn(Boolean(res.access_token));
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    // eslint-disable-next-line no-console
                    console.error(e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        url
    ]);
    useEffect(function() {
        getAccountSession();
    }, [
        getAccountSession
    ]);
    var handleShowLogin = useCallback(function(show) {
        setShowLogin(show);
        if (show) {
            analytics.gtm.trackShowLogin({
                isLoggedIn: isLoggedIn
            });
        }
    }, [
        isLoggedIn
    ]);
    var handleShowMobileLogin = useCallback(function(show) {
        setShowMobileLogin(show);
        if (show) {
            analytics.gtm.trackShowLogin({
                isLoggedIn: isLoggedIn
            });
        }
    }, [
        isLoggedIn
    ]);
    var value = useMemo(function() {
        return {
            isLoggedIn: isLoggedIn,
            setLoggedIn: setLoggedIn,
            error: error,
            setError: setError,
            showLogin: showLogin,
            setShowLogin: handleShowLogin,
            showMobileLogin: showMobileLogin,
            setShowMobileLogin: handleShowMobileLogin,
            securityToken: sessionData.securityTokenValue || "",
            username: username,
            setUsername: setUsername
        };
    }, [
        error,
        handleShowLogin,
        handleShowMobileLogin,
        isLoggedIn,
        sessionData.securityTokenValue,
        showLogin,
        showMobileLogin,
        username, 
    ]);
    return /*#__PURE__*/ _jsx(LoginContext.Provider, {
        value: value,
        children: children
    });
};
export { LoginProvider };
